import { c as _c } from "react/compiler-runtime";
import { Flex, Icon } from '@chakra-ui/react';
import { LuUserRound } from 'react-icons/lu';
const SIZE_PX = {
  md: 10,
  lg: 12,
  xl: 16
} as const;
type OpenSeatAvatarProps = {
  label?: string;
  size?: keyof typeof SIZE_PX;
};

/** Vacant-seat mark — unknown-person silhouette in a dashed circle. */
export const OpenSeatAvatar = t0 => {
  const $ = _c(4);
  const {
    label: t1,
    size: t2
  } = t0;
  const label = t1 === undefined ? "Open board seat" : t1;
  const size = t2 === undefined ? "lg" : t2;
  const t3 = SIZE_PX[size];
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Icon boxSize="55%"><LuUserRound /></Icon>;
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] !== label || $[2] !== t3) {
    t5 = <Flex align="center" aria-label={label} bg="colorPalette.subtle" borderColor="colorPalette.border" borderRadius="full" borderStyle="dashed" borderWidth="2px" boxSize={t3} color="colorPalette.fg" flexShrink={0} justify="center" role="img">{t4}</Flex>;
    $[1] = label;
    $[2] = t3;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  return t5;
};